import React from "react";
import "./Summary.css";
const Summary = ({ data }) => {
  const summaryData = data?.[0];

  const isValid = (str) => {
    return (
      str &&
      typeof str === "string" &&
      str.trim() &&
      !str.toUpperCase().includes("N/A") &&
      !str.toUpperCase().includes("NULL") &&
      !str.includes("  ")
    );
  };

  const summaries = [
    summaryData?.participation_summary,
    summaryData?.best_grade_performance,
    summaryData?.improvement_recommendation,
    summaryData?.subject_performance,
  ].filter(isValid);

  return (
    <div className="SR_Summary_Cont">
      <ul className="SR_Summary_list_Cont">
        {summaries.map((summary, index) => (
          <li key={index}>{summary}</li>
        ))}
      </ul>
    </div>
  );
};

export default Summary;
